import { internalDashboardApiBase as api } from '../../api/internalDashboardApiBase';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    vendorCustomerClassSearchList: build.query<
      VendorCustomerClassSearchListApiResponse,
      VendorCustomerClassSearchListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-class/search/`,
        params: {
          name: queryArg.name,
          page_number: queryArg.pageNumber,
          per_page: queryArg.perPage,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    vendorCustomerClassesList: build.query<
      VendorCustomerClassesListApiResponse,
      VendorCustomerClassesListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-classes/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
    }),
    vendorCustomerClassesCreate: build.mutation<
      VendorCustomerClassesCreateApiResponse,
      VendorCustomerClassesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-classes/`,
        method: 'POST',
        body: queryArg.customerClassRequestRequest,
      }),
    }),
    vendorCustomerClassesRetrieve: build.query<
      VendorCustomerClassesRetrieveApiResponse,
      VendorCustomerClassesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-classes/${queryArg.id}/`,
      }),
    }),
    vendorCustomerClassesUpdate: build.mutation<
      VendorCustomerClassesUpdateApiResponse,
      VendorCustomerClassesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-classes/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.customerClassRequestRequest,
      }),
    }),
    vendorCustomerClassesDestroy: build.mutation<
      VendorCustomerClassesDestroyApiResponse,
      VendorCustomerClassesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-classes/${queryArg.id}/`,
        method: 'DELETE',
      }),
    }),
    vendorCustomerLocationsBillingStatusUpdate: build.mutation<
      VendorCustomerLocationsBillingStatusUpdateApiResponse,
      VendorCustomerLocationsBillingStatusUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-locations/${queryArg.locationId}/billing-status/`,
        method: 'PUT',
        body: queryArg.locationBillingStatusUpdateRequest,
      }),
    }),
    vendorCustomerLocationsPaymentTermsUpdate: build.mutation<
      VendorCustomerLocationsPaymentTermsUpdateApiResponse,
      VendorCustomerLocationsPaymentTermsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-locations/${queryArg.locationId}/payment-terms/`,
        method: 'PUT',
        body: queryArg.locationPaymentTermsUpdateRequest,
      }),
    }),
    vendorCustomerLocationsBillingStatusBulkUpdateCreate: build.mutation<
      VendorCustomerLocationsBillingStatusBulkUpdateCreateApiResponse,
      VendorCustomerLocationsBillingStatusBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-locations/billing-status/bulk-update/`,
        method: 'POST',
        body: queryArg.locationBillingStatusBulkUpdateRequest,
      }),
    }),
    vendorCustomerLocationsPaymentTermsBulkUpdateCreate: build.mutation<
      VendorCustomerLocationsPaymentTermsBulkUpdateCreateApiResponse,
      VendorCustomerLocationsPaymentTermsBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-locations/payment-terms/bulk-update/`,
        method: 'POST',
        body: queryArg.locationPaymentTermsBulkUpdateRequest,
      }),
    }),
    vendorCustomerTaxesFeesList: build.query<
      VendorCustomerTaxesFeesListApiResponse,
      VendorCustomerTaxesFeesListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-taxes-fees/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
          search: queryArg.search,
        },
      }),
    }),
    vendorCustomerTaxesFeesBulkUpdateCreate: build.mutation<
      VendorCustomerTaxesFeesBulkUpdateCreateApiResponse,
      VendorCustomerTaxesFeesBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer-taxes-fees/bulk-update/`,
        method: 'POST',
        body: queryArg.customerTaxesFeesBulkUpdateRequestRequest,
      }),
    }),
    vendorCustomerActivitiesList: build.query<
      VendorCustomerActivitiesListApiResponse,
      VendorCustomerActivitiesListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/`,
        params: {
          activity_status: queryArg.activityStatus,
          activity_type: queryArg.activityType,
          from_date: queryArg.fromDate,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          title: queryArg.title,
          to_date: queryArg.toDate,
          user_id: queryArg.userId,
        },
      }),
    }),
    vendorCustomerActivitiesCreate: build.mutation<
      VendorCustomerActivitiesCreateApiResponse,
      VendorCustomerActivitiesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/`,
        method: 'POST',
        body: queryArg.activityRequestRequest,
      }),
    }),
    vendorCustomerActivitiesRetrieve: build.query<
      VendorCustomerActivitiesRetrieveApiResponse,
      VendorCustomerActivitiesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/${queryArg.id}/`,
      }),
    }),
    vendorCustomerActivitiesUpdate: build.mutation<
      VendorCustomerActivitiesUpdateApiResponse,
      VendorCustomerActivitiesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.activityRequestRequest,
      }),
    }),
    vendorCustomerActivitiesDestroy: build.mutation<
      VendorCustomerActivitiesDestroyApiResponse,
      VendorCustomerActivitiesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/${queryArg.id}/`,
        method: 'DELETE',
      }),
    }),
    vendorCustomerActivitiesExportCreate: build.mutation<
      VendorCustomerActivitiesExportCreateApiResponse,
      VendorCustomerActivitiesExportCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/activities/export/`,
        method: 'POST',
        body: queryArg.activityExportRequest,
      }),
    }),
    vendorCustomerContactsList: build.query<
      VendorCustomerContactsListApiResponse,
      VendorCustomerContactsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customer/${queryArg.customerId}/contacts/`,
      }),
    }),
    vendorCustomersList: build.query<
      VendorCustomersListApiResponse,
      VendorCustomersListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/`,
        params: {
          basis_date: queryArg.basisDate,
          billing_status: queryArg.billingStatus,
          customer_class: queryArg.customerClass,
          from_date: queryArg.fromDate,
          has_orders: queryArg.hasOrders,
          ordering: queryArg.ordering,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          payment_terms: queryArg.paymentTerms,
          sales_rep: queryArg.salesRep,
          search: queryArg.search,
          to_date: queryArg.toDate,
        },
      }),
    }),
    vendorCustomersContactsList: build.query<
      VendorCustomersContactsListApiResponse,
      VendorCustomersContactsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/contacts/`,
      }),
    }),
    vendorCustomersContactsCreate: build.mutation<
      VendorCustomersContactsCreateApiResponse,
      VendorCustomersContactsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/contacts/`,
        method: 'POST',
        body: queryArg.contactRequestRequest,
      }),
    }),
    vendorCustomersContactsUpdate: build.mutation<
      VendorCustomersContactsUpdateApiResponse,
      VendorCustomersContactsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/contacts/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.contactRequestRequest,
      }),
    }),
    vendorCustomersContactsDestroy: build.mutation<
      VendorCustomersContactsDestroyApiResponse,
      VendorCustomersContactsDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/contacts/${queryArg.id}/`,
        method: 'DELETE',
      }),
    }),
    vendorCustomersDetailsRetrieve: build.query<
      VendorCustomersDetailsRetrieveApiResponse,
      VendorCustomersDetailsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/details/`,
      }),
    }),
    vendorCustomersDetailsPartialUpdate: build.mutation<
      VendorCustomersDetailsPartialUpdateApiResponse,
      VendorCustomersDetailsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/details/`,
        method: 'PATCH',
        body: queryArg.patchedCustomerSettingsRequest,
      }),
    }),
    vendorCustomersLocationsRetrieve: build.query<
      VendorCustomersLocationsRetrieveApiResponse,
      VendorCustomersLocationsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/locations/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
        },
      }),
    }),
    vendorCustomersLocationsSalesRepsPartialUpdate: build.mutation<
      VendorCustomersLocationsSalesRepsPartialUpdateApiResponse,
      VendorCustomersLocationsSalesRepsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/locations/${queryArg.locationId}/sales-reps/`,
        method: 'PATCH',
        body: queryArg.patchedLocationSalesRepsRequest,
      }),
    }),
    vendorCustomersNotesList: build.query<
      VendorCustomersNotesListApiResponse,
      VendorCustomersNotesListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/notes/`,
      }),
    }),
    vendorCustomersNotesCreate: build.mutation<
      VendorCustomersNotesCreateApiResponse,
      VendorCustomersNotesCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/notes/`,
        method: 'POST',
        body: queryArg.noteRequestRequest,
      }),
    }),
    vendorCustomersNotesUpdate: build.mutation<
      VendorCustomersNotesUpdateApiResponse,
      VendorCustomersNotesUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/notes/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.noteRequestRequest,
      }),
    }),
    vendorCustomersNotesDestroy: build.mutation<
      VendorCustomersNotesDestroyApiResponse,
      VendorCustomersNotesDestroyApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/${queryArg.customerId}/notes/${queryArg.id}/`,
        method: 'DELETE',
      }),
    }),
    vendorCustomersBulkUpdateCreate: build.mutation<
      VendorCustomersBulkUpdateCreateApiResponse,
      VendorCustomersBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/bulk-update/`,
        method: 'POST',
        body: queryArg.customerBulkUpdateRequest,
      }),
    }),
    vendorCustomersBulkUpdateChoicesRetrieve: build.query<
      VendorCustomersBulkUpdateChoicesRetrieveApiResponse,
      VendorCustomersBulkUpdateChoicesRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/customers/bulk-update/choices/`,
      }),
    }),
    vendorImportBatchesImportProductsList: build.query<
      VendorImportBatchesImportProductsListApiResponse,
      VendorImportBatchesImportProductsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-products/`,
        params: {
          pageNumber: queryArg.pageNumber,
          perPage: queryArg.perPage,
          readyToImport: queryArg.readyToImport,
          selectedForImport: queryArg.selectedForImport,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          synced: queryArg.synced,
        },
      }),
    }),
    vendorImportBatchesImportProductsPartialUpdate: build.mutation<
      VendorImportBatchesImportProductsPartialUpdateApiResponse,
      VendorImportBatchesImportProductsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-products/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedImportProductPartialUpdateRequest,
      }),
    }),
    vendorImportBatchesImportProductsDeselectAllCreate: build.mutation<
      VendorImportBatchesImportProductsDeselectAllCreateApiResponse,
      VendorImportBatchesImportProductsDeselectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-products/deselect-all/`,
        method: 'POST',
      }),
    }),
    vendorImportBatchesImportProductsSelectAllCreate: build.mutation<
      VendorImportBatchesImportProductsSelectAllCreateApiResponse,
      VendorImportBatchesImportProductsSelectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-products/select-all/`,
        method: 'POST',
      }),
    }),
    vendorImportBatchesImportProductsValidateRetrieve: build.query<
      VendorImportBatchesImportProductsValidateRetrieveApiResponse,
      VendorImportBatchesImportProductsValidateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-products/validate/`,
      }),
    }),
    vendorImportBatchesImportStrainsList: build.query<
      VendorImportBatchesImportStrainsListApiResponse,
      VendorImportBatchesImportStrainsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-strains/`,
        params: {
          pageNumber: queryArg.pageNumber,
          perPage: queryArg.perPage,
          readyToImport: queryArg.readyToImport,
          selectedForImport: queryArg.selectedForImport,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          synced: queryArg.synced,
        },
      }),
    }),
    vendorImportBatchesImportStrainsPartialUpdate: build.mutation<
      VendorImportBatchesImportStrainsPartialUpdateApiResponse,
      VendorImportBatchesImportStrainsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-strains/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedImportStrainPartialUpdateRequest,
      }),
    }),
    vendorImportBatchesImportStrainsDeselectAllCreate: build.mutation<
      VendorImportBatchesImportStrainsDeselectAllCreateApiResponse,
      VendorImportBatchesImportStrainsDeselectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-strains/deselect-all/`,
        method: 'POST',
      }),
    }),
    vendorImportBatchesImportStrainsSelectAllCreate: build.mutation<
      VendorImportBatchesImportStrainsSelectAllCreateApiResponse,
      VendorImportBatchesImportStrainsSelectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-strains/select-all/`,
        method: 'POST',
      }),
    }),
    vendorImportBatchesImportStrainsValidateRetrieve: build.query<
      VendorImportBatchesImportStrainsValidateRetrieveApiResponse,
      VendorImportBatchesImportStrainsValidateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-strains/validate/`,
      }),
    }),
    vendorImportBatchesImportVariantsList: build.query<
      VendorImportBatchesImportVariantsListApiResponse,
      VendorImportBatchesImportVariantsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-variants/`,
        params: {
          isBucket: queryArg.isBucket,
          pageNumber: queryArg.pageNumber,
          perPage: queryArg.perPage,
          readyToImport: queryArg.readyToImport,
          selectedForImport: queryArg.selectedForImport,
          sortBy: queryArg.sortBy,
          sortOrder: queryArg.sortOrder,
          synced: queryArg.synced,
        },
      }),
    }),
    vendorImportBatchesImportVariantsPartialUpdate: build.mutation<
      VendorImportBatchesImportVariantsPartialUpdateApiResponse,
      VendorImportBatchesImportVariantsPartialUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-variants/${queryArg.id}/`,
        method: 'PATCH',
        body: queryArg.patchedImportVariantPartialUpdateRequest,
      }),
    }),
    vendorImportBatchesImportVariantsDeselectAllCreate: build.mutation<
      VendorImportBatchesImportVariantsDeselectAllCreateApiResponse,
      VendorImportBatchesImportVariantsDeselectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-variants/deselect-all/`,
        method: 'POST',
        params: {
          isBucket: queryArg.isBucket,
        },
      }),
    }),
    vendorImportBatchesImportVariantsSelectAllCreate: build.mutation<
      VendorImportBatchesImportVariantsSelectAllCreateApiResponse,
      VendorImportBatchesImportVariantsSelectAllCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-variants/select-all/`,
        method: 'POST',
        params: {
          isBucket: queryArg.isBucket,
        },
      }),
    }),
    vendorImportBatchesImportVariantsValidateRetrieve: build.query<
      VendorImportBatchesImportVariantsValidateRetrieveApiResponse,
      VendorImportBatchesImportVariantsValidateRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.importBatchId}/import-variants/validate/`,
      }),
    }),
    vendorImportBatchesProcessCreate: build.mutation<
      VendorImportBatchesProcessCreateApiResponse,
      VendorImportBatchesProcessCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/import-batches/${queryArg.id}/process/`,
        method: 'POST',
      }),
    }),
    vendorLocationsList: build.query<
      VendorLocationsListApiResponse,
      VendorLocationsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/locations/`,
        params: {
          customer_class: queryArg.customerClass,
          engagement_status: queryArg.engagementStatus,
          location_status: queryArg.locationStatus,
          ordering: queryArg.ordering,
          page: queryArg.page,
          page_size: queryArg.pageSize,
          sales_rep: queryArg.salesRep,
          search: queryArg.search,
        },
      }),
    }),
    vendorLocationsBulkUpdateCreate: build.mutation<
      VendorLocationsBulkUpdateCreateApiResponse,
      VendorLocationsBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/locations/bulk-update/`,
        method: 'POST',
        body: queryArg.locationBulkUpdateRequest,
      }),
    }),
    vendorLocationsCustomerClassesBulkUpdateCreate: build.mutation<
      VendorLocationsCustomerClassesBulkUpdateCreateApiResponse,
      VendorLocationsCustomerClassesBulkUpdateCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/locations/customer-classes/bulk-update/`,
        method: 'POST',
        body: queryArg.locationCustomerClassesBulkUpdateRequest,
      }),
    }),
    vendorSalesChannelsList: build.query<
      VendorSalesChannelsListApiResponse,
      VendorSalesChannelsListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/sales-channels/`,
        params: {
          page: queryArg.page,
          page_size: queryArg.pageSize,
          search: queryArg.search,
          status: queryArg.status,
        },
      }),
    }),
    vendorSalesChannelsCreate: build.mutation<
      VendorSalesChannelsCreateApiResponse,
      VendorSalesChannelsCreateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/sales-channels/`,
        method: 'POST',
        body: queryArg.salesChannelRequestRequest,
      }),
    }),
    vendorSalesChannelsRetrieve: build.query<
      VendorSalesChannelsRetrieveApiResponse,
      VendorSalesChannelsRetrieveApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/sales-channels/${queryArg.id}/`,
      }),
    }),
    vendorSalesChannelsUpdate: build.mutation<
      VendorSalesChannelsUpdateApiResponse,
      VendorSalesChannelsUpdateApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/sales-channels/${queryArg.id}/`,
        method: 'PUT',
        body: queryArg.salesChannelRequestRequest,
      }),
    }),
    vendorSalesRepSearchList: build.query<
      VendorSalesRepSearchListApiResponse,
      VendorSalesRepSearchListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/sales-rep/search/`,
        params: {
          name: queryArg.name,
          page_number: queryArg.pageNumber,
          per_page: queryArg.perPage,
          sort_by: queryArg.sortBy,
          sort_order: queryArg.sortOrder,
        },
      }),
    }),
    vendorVendorUsersList: build.query<
      VendorVendorUsersListApiResponse,
      VendorVendorUsersListApiArg
    >({
      query: (queryArg) => ({
        url: `/vendor/${queryArg.vendorId}/vendor-users/`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as internalDashboardApi };
export type VendorCustomerClassSearchListApiResponse =
  /** status 200  */ LookupResponse;
export type VendorCustomerClassSearchListApiArg = {
  /** Case-insensitive partial match on class name. */
  name?: string;
  /** Page number (1-based). */
  pageNumber?: number;
  /** Items per page. */
  perPage?: number;
  /** Sort field. Defaults to `name`. */
  sortBy?: string;
  /** Sort direction. */
  sortOrder?: 'asc' | 'desc';
  vendorId: number;
};
export type VendorCustomerClassesListApiResponse =
  /** status 200  */ CustomerClassesListResponse;
export type VendorCustomerClassesListApiArg = {
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Filter by class name or description. */
  search?: string;
  vendorId: number;
};
export type VendorCustomerClassesCreateApiResponse =
  /** status 201  */ CustomerClassResponseRead;
export type VendorCustomerClassesCreateApiArg = {
  vendorId: number;
  customerClassRequestRequest: CustomerClassRequestRequest;
};
export type VendorCustomerClassesRetrieveApiResponse =
  /** status 200  */ CustomerClassResponseRead;
export type VendorCustomerClassesRetrieveApiArg = {
  /** Customer class ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomerClassesUpdateApiResponse =
  /** status 200  */ CustomerClassResponseRead;
export type VendorCustomerClassesUpdateApiArg = {
  /** Customer class ID. */
  id: number;
  vendorId: number;
  customerClassRequestRequest: CustomerClassRequestRequest;
};
export type VendorCustomerClassesDestroyApiResponse =
  /** status 204  */ SuccessResponse;
export type VendorCustomerClassesDestroyApiArg = {
  /** Customer class ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomerLocationsBillingStatusUpdateApiResponse =
  /** status 200  */ LocationBillingStatusUpdateResult;
export type VendorCustomerLocationsBillingStatusUpdateApiArg = {
  /** ID of the dispensary location to update. */
  locationId: number;
  vendorId: number;
  locationBillingStatusUpdateRequest: LocationBillingStatusUpdateRequest;
};
export type VendorCustomerLocationsPaymentTermsUpdateApiResponse =
  /** status 200  */ LocationPaymentTermsUpdateResult;
export type VendorCustomerLocationsPaymentTermsUpdateApiArg = {
  /** ID of the dispensary location to update. */
  locationId: number;
  vendorId: number;
  locationPaymentTermsUpdateRequest: LocationPaymentTermsUpdateRequest;
};
export type VendorCustomerLocationsBillingStatusBulkUpdateCreateApiResponse =
  /** status 200  */ LocationBillingStatusBulkUpdateResult;
export type VendorCustomerLocationsBillingStatusBulkUpdateCreateApiArg = {
  vendorId: number;
  locationBillingStatusBulkUpdateRequest: LocationBillingStatusBulkUpdateRequest;
};
export type VendorCustomerLocationsPaymentTermsBulkUpdateCreateApiResponse =
  /** status 200  */ LocationPaymentTermsBulkUpdateResult;
export type VendorCustomerLocationsPaymentTermsBulkUpdateCreateApiArg = {
  vendorId: number;
  locationPaymentTermsBulkUpdateRequest: LocationPaymentTermsBulkUpdateRequest;
};
export type VendorCustomerTaxesFeesListApiResponse =
  /** status 200  */ CustomerTaxesFeesListResponse;
export type VendorCustomerTaxesFeesListApiArg = {
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Filter by location name or customer name. */
  search?: string;
  vendorId: number;
};
export type VendorCustomerTaxesFeesBulkUpdateCreateApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomerTaxesFeesBulkUpdateCreateApiArg = {
  vendorId: number;
  customerTaxesFeesBulkUpdateRequestRequest: CustomerTaxesFeesBulkUpdateRequestRequest;
};
export type VendorCustomerActivitiesListApiResponse =
  /** status 200  */ ActivitiesListResponseRead;
export type VendorCustomerActivitiesListApiArg = {
  /** Repeat this query parameter to filter by multiple activity statuses. */
  activityStatus?: string;
  /** Repeat this query parameter to filter by multiple activity types. */
  activityType?: string;
  customerId: number;
  /** Filter activities due on or after this date. */
  fromDate?: string;
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Filter by activity title. */
  title?: string;
  /** Filter activities due on or before this date. */
  toDate?: string;
  /** Repeat this query parameter to filter by multiple vendor user IDs. */
  userId?: number;
  vendorId: number;
};
export type VendorCustomerActivitiesCreateApiResponse =
  /** status 201  */ ActivityResponseRead;
export type VendorCustomerActivitiesCreateApiArg = {
  customerId: number;
  vendorId: number;
  activityRequestRequest: ActivityRequestRequest;
};
export type VendorCustomerActivitiesRetrieveApiResponse =
  /** status 200  */ ActivityResponseRead;
export type VendorCustomerActivitiesRetrieveApiArg = {
  customerId: number;
  /** Activity ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomerActivitiesUpdateApiResponse =
  /** status 200  */ ActivityResponseRead;
export type VendorCustomerActivitiesUpdateApiArg = {
  customerId: number;
  /** Activity ID. */
  id: number;
  vendorId: number;
  activityRequestRequest: ActivityRequestRequest;
};
export type VendorCustomerActivitiesDestroyApiResponse =
  /** status 204  */ SuccessResponse;
export type VendorCustomerActivitiesDestroyApiArg = {
  customerId: number;
  /** Activity ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomerActivitiesExportCreateApiResponse =
  /** status 200  */ Blob;
export type VendorCustomerActivitiesExportCreateApiArg = {
  customerId: number;
  vendorId: number;
  activityExportRequest: ActivityExportRequest;
};
export type VendorCustomerContactsListApiResponse =
  /** status 200  */ ContactsListResponseRead;
export type VendorCustomerContactsListApiArg = {
  customerId: number;
  vendorId: number;
};
export type VendorCustomersListApiResponse =
  /** status 200  */ CustomerSummaryPaginatedResponse;
export type VendorCustomersListApiArg = {
  /** Comma-separated basis date values. */
  basisDate?: string;
  /** Comma-separated billing status values. */
  billingStatus?: string;
  /** Comma-separated customer class IDs. Use `0` or `none` to include unclassified. */
  customerClass?: string;
  /** Filter to customers whose last order (across accessible locations) was on or after this instant (inclusive). */
  fromDate?: string;
  /** Comma-separated order-history filter values: has_orders, no_orders. Selecting both values is equivalent to no filter. */
  hasOrders?: string;
  /** Sort field. Prefix with `-` for descending. Accepted values: customerId, customerName, numberOfLocations, totalDollarsOrdered, numberOfOrders, averageTotalPerOrder, lastOrderDate, basisDate, billingStatus, defaultSalesRep, defaultPaymentTerms. */
  ordering?: string;
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Comma-separated payment terms values. Use `none` to include customers without terms. */
  paymentTerms?: string;
  /** Comma-separated sales rep IDs. Use `0` or `none` to include unassigned. */
  salesRep?: string;
  /** Filter by customer name (case-insensitive contains). */
  search?: string;
  /** Filter to customers whose last order (across accessible locations) was on or before this instant (inclusive). */
  toDate?: string;
  vendorId: number;
};
export type VendorCustomersContactsListApiResponse =
  /** status 200  */ ContactsListResponseRead;
export type VendorCustomersContactsListApiArg = {
  customerId: number;
  vendorId: number;
};
export type VendorCustomersContactsCreateApiResponse =
  /** status 201  */ ContactMutationResponseRead;
export type VendorCustomersContactsCreateApiArg = {
  customerId: number;
  vendorId: number;
  contactRequestRequest: ContactRequestRequest;
};
export type VendorCustomersContactsUpdateApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomersContactsUpdateApiArg = {
  customerId: number;
  /** Contact ID. */
  id: number;
  vendorId: number;
  contactRequestRequest: ContactRequestRequest;
};
export type VendorCustomersContactsDestroyApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomersContactsDestroyApiArg = {
  customerId: number;
  /** Contact ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomersDetailsRetrieveApiResponse =
  /** status 200  */ CustomerDetailsResponseEnvelope;
export type VendorCustomersDetailsRetrieveApiArg = {
  customerId: number;
  vendorId: number;
};
export type VendorCustomersDetailsPartialUpdateApiResponse =
  /** status 200  */ CustomerDetailsUpdateResponse;
export type VendorCustomersDetailsPartialUpdateApiArg = {
  customerId: number;
  vendorId: number;
  patchedCustomerSettingsRequest: PatchedCustomerSettingsRequest;
};
export type VendorCustomersLocationsRetrieveApiResponse =
  /** status 200  */ CustomerDetailsLocationsResponse;
export type VendorCustomersLocationsRetrieveApiArg = {
  customerId: number;
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  vendorId: number;
};
export type VendorCustomersLocationsSalesRepsPartialUpdateApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomersLocationsSalesRepsPartialUpdateApiArg = {
  customerId: number;
  locationId: number;
  /** ID of the customer location to update. */
  locationPk: number;
  vendorId: number;
  patchedLocationSalesRepsRequest: PatchedLocationSalesRepsRequest;
};
export type VendorCustomersNotesListApiResponse =
  /** status 200  */ NotesListResponseRead;
export type VendorCustomersNotesListApiArg = {
  customerId: number;
  vendorId: number;
};
export type VendorCustomersNotesCreateApiResponse =
  /** status 201  */ NoteMutationResponseRead;
export type VendorCustomersNotesCreateApiArg = {
  customerId: number;
  vendorId: number;
  noteRequestRequest: NoteRequestRequest;
};
export type VendorCustomersNotesUpdateApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomersNotesUpdateApiArg = {
  customerId: number;
  /** Note ID. */
  id: number;
  vendorId: number;
  noteRequestRequest: NoteRequestRequest;
};
export type VendorCustomersNotesDestroyApiResponse =
  /** status 200  */ SuccessResponse;
export type VendorCustomersNotesDestroyApiArg = {
  customerId: number;
  /** Note ID. */
  id: number;
  vendorId: number;
};
export type VendorCustomersBulkUpdateCreateApiResponse =
  /** status 200  */ CustomerBulkUpdateResult;
export type VendorCustomersBulkUpdateCreateApiArg = {
  vendorId: number;
  customerBulkUpdateRequest: CustomerBulkUpdateRequest;
};
export type VendorCustomersBulkUpdateChoicesRetrieveApiResponse =
  /** status 200  */ BulkUpdateChoicesResponse;
export type VendorCustomersBulkUpdateChoicesRetrieveApiArg = {
  vendorId: number;
};
export type VendorImportBatchesImportProductsListApiResponse =
  /** status 200  */ ImportProductListResponseRead;
export type VendorImportBatchesImportProductsListApiArg = {
  importBatchId: number;
  /** Page number (1-based). */
  pageNumber?: number;
  /** Page size (number of items per page). */
  perPage?: number;
  /** Filter to records that are or are not complete for import purposes. */
  readyToImport?: boolean;
  /** Filter to records that have or have not been selected for import. */
  selectedForImport?: boolean;
  /** Attribute to sort by. */
  sortBy?: string;
  /** Order (asc/desc) to sort by. */
  sortOrder?: string;
  /** Filter to records that have or have not already been synced. */
  synced?: boolean;
  vendorId: number;
};
export type VendorImportBatchesImportProductsPartialUpdateApiResponse =
  /** status 200  */ ImportProductPartialUpdateResponseRead;
export type VendorImportBatchesImportProductsPartialUpdateApiArg = {
  /** Model instance primary key. */
  id: number;
  importBatchId: number;
  vendorId: number;
  patchedImportProductPartialUpdateRequest: PatchedImportProductPartialUpdateRequestWrite;
};
export type VendorImportBatchesImportProductsDeselectAllCreateApiResponse =
  /** status 200  */ ImportProductDeselectAllResponse;
export type VendorImportBatchesImportProductsDeselectAllCreateApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportProductsSelectAllCreateApiResponse =
  /** status 200  */ ImportProductSelectAllResponse;
export type VendorImportBatchesImportProductsSelectAllCreateApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportProductsValidateRetrieveApiResponse =
  /** status 200  */ ImportProductValidateResponse;
export type VendorImportBatchesImportProductsValidateRetrieveApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportStrainsListApiResponse =
  /** status 200  */ ImportStrainListResponseRead;
export type VendorImportBatchesImportStrainsListApiArg = {
  importBatchId: number;
  /** Page number (1-based). */
  pageNumber?: number;
  /** Page size (number of items per page). */
  perPage?: number;
  /** Filter to records that are or are not complete for import purposes. */
  readyToImport?: boolean;
  /** Filter to records that have or have not been selected for import. */
  selectedForImport?: boolean;
  /** Attribute to sort by. */
  sortBy?: string;
  /** Order (asc/desc) to sort by. */
  sortOrder?: string;
  /** Filter to records that have or have not already been synced. */
  synced?: boolean;
  vendorId: number;
};
export type VendorImportBatchesImportStrainsPartialUpdateApiResponse =
  /** status 200  */ ImportStrainPartialUpdateResponseRead;
export type VendorImportBatchesImportStrainsPartialUpdateApiArg = {
  /** Model instance primary key. */
  id: number;
  importBatchId: number;
  vendorId: number;
  patchedImportStrainPartialUpdateRequest: PatchedImportStrainPartialUpdateRequest;
};
export type VendorImportBatchesImportStrainsDeselectAllCreateApiResponse =
  /** status 200  */ ImportStrainDeselectAllResponse;
export type VendorImportBatchesImportStrainsDeselectAllCreateApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportStrainsSelectAllCreateApiResponse =
  /** status 200  */ ImportStrainSelectAllResponse;
export type VendorImportBatchesImportStrainsSelectAllCreateApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportStrainsValidateRetrieveApiResponse =
  /** status 200  */ ImportStrainValidateResponse;
export type VendorImportBatchesImportStrainsValidateRetrieveApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesImportVariantsListApiResponse =
  /** status 200  */ ImportVariantListResponseRead;
export type VendorImportBatchesImportVariantsListApiArg = {
  importBatchId: number;
  /** Filter to records that are weight-based or pre-pack. */
  isBucket?: boolean;
  /** Page number (1-based). */
  pageNumber?: number;
  /** Page size (number of items per page). */
  perPage?: number;
  /** Filter to records that are or are not complete for import purposes. */
  readyToImport?: boolean;
  /** Filter to records that have or have not been selected for import. */
  selectedForImport?: boolean;
  /** Attribute to sort by. */
  sortBy?: string;
  /** Order (asc/desc) to sort by. */
  sortOrder?: string;
  /** Filter to records that have or have not already been synced. */
  synced?: boolean;
  vendorId: number;
};
export type VendorImportBatchesImportVariantsPartialUpdateApiResponse =
  /** status 200  */ ImportVariantPartialUpdateResponseRead;
export type VendorImportBatchesImportVariantsPartialUpdateApiArg = {
  /** Model instance primary key. */
  id: number;
  importBatchId: number;
  vendorId: number;
  patchedImportVariantPartialUpdateRequest: PatchedImportVariantPartialUpdateRequest;
};
export type VendorImportBatchesImportVariantsDeselectAllCreateApiResponse =
  /** status 200  */ ImportVariantDeselectAllResponse;
export type VendorImportBatchesImportVariantsDeselectAllCreateApiArg = {
  importBatchId: number;
  /** Filter to records that are weight-based or pre-pack. */
  isBucket?: boolean;
  vendorId: number;
};
export type VendorImportBatchesImportVariantsSelectAllCreateApiResponse =
  /** status 200  */ ImportVariantSelectAllResponse;
export type VendorImportBatchesImportVariantsSelectAllCreateApiArg = {
  importBatchId: number;
  /** Filter to records that are weight-based or pre-pack. */
  isBucket?: boolean;
  vendorId: number;
};
export type VendorImportBatchesImportVariantsValidateRetrieveApiResponse =
  /** status 200  */ ImportVariantValidateResponse;
export type VendorImportBatchesImportVariantsValidateRetrieveApiArg = {
  importBatchId: number;
  vendorId: number;
};
export type VendorImportBatchesProcessCreateApiResponse = unknown;
export type VendorImportBatchesProcessCreateApiArg = {
  /** Model instance primary key. */
  id: number;
  vendorId: number;
};
export type VendorLocationsListApiResponse =
  /** status 200  */ CustomerLocationPaginatedResponse;
export type VendorLocationsListApiArg = {
  /** Comma-separated customer class IDs. Use `0` or `none` to include unclassified. */
  customerClass?: string;
  /** Filter by engagement status (based on 365-day order threshold). */
  engagementStatus?: 'all_statuses' | 'engaged' | 'not_engaged';
  /** Filter by location status. */
  locationStatus?: 'active' | 'all_locations' | 'archived' | 'inactive';
  /** Sort field. Prefix with `-` for descending. Accepted values: locationId, customerName, locationName, licenseNumber, numberOfOrders, totalDollarsOrdered, averageTotalPerOrder, salesRep, paymentTerms, billingStatus, locationStatus. */
  ordering?: string;
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Comma-separated sales rep IDs. Use `0` or `none` to include unassigned. */
  salesRep?: string;
  /** Filter by location name, customer name, or license number (case-insensitive contains). */
  search?: string;
  vendorId: number;
};
export type VendorLocationsBulkUpdateCreateApiResponse =
  /** status 200  */ LocationBulkUpdateResult;
export type VendorLocationsBulkUpdateCreateApiArg = {
  vendorId: number;
  locationBulkUpdateRequest: LocationBulkUpdateRequest;
};
export type VendorLocationsCustomerClassesBulkUpdateCreateApiResponse =
  /** status 200  */ LocationCustomerClassesBulkUpdateResult;
export type VendorLocationsCustomerClassesBulkUpdateCreateApiArg = {
  vendorId: number;
  locationCustomerClassesBulkUpdateRequest: LocationCustomerClassesBulkUpdateRequest;
};
export type VendorSalesChannelsListApiResponse =
  /** status 200  */ SalesChannelsListResponseRead;
export type VendorSalesChannelsListApiArg = {
  /** Page number (1-based). */
  page?: number;
  /** Page size (number of items per page). */
  pageSize?: number;
  /** Filter by channel name. */
  search?: string;
  /** Filter by status; use `active` or `inactive`. Omit for all channels. */
  status?: 'active' | 'inactive';
  vendorId: number;
};
export type VendorSalesChannelsCreateApiResponse =
  /** status 201  */ SalesChannelResponseRead;
export type VendorSalesChannelsCreateApiArg = {
  vendorId: number;
  salesChannelRequestRequest: SalesChannelRequestRequest;
};
export type VendorSalesChannelsRetrieveApiResponse =
  /** status 200  */ SalesChannelResponseRead;
export type VendorSalesChannelsRetrieveApiArg = {
  /** Sales channel ID. */
  id: number;
  vendorId: number;
};
export type VendorSalesChannelsUpdateApiResponse =
  /** status 200  */ SalesChannelResponseRead;
export type VendorSalesChannelsUpdateApiArg = {
  /** Sales channel ID. */
  id: number;
  vendorId: number;
  salesChannelRequestRequest: SalesChannelRequestRequest;
};
export type VendorSalesRepSearchListApiResponse =
  /** status 200  */ LookupResponse;
export type VendorSalesRepSearchListApiArg = {
  /** Case-insensitive partial match on first name, last name, or email. */
  name?: string;
  /** Page number (1-based). */
  pageNumber?: number;
  /** Items per page. */
  perPage?: number;
  /** Sort field. Defaults to `name`. */
  sortBy?: string;
  /** Sort direction. */
  sortOrder?: 'asc' | 'desc';
  vendorId: number;
};
export type VendorVendorUsersListApiResponse =
  /** status 200  */ VendorUsersListResponseRead;
export type VendorVendorUsersListApiArg = {
  vendorId: number;
};
export type LookupItem = {
  id: number;
  name: string;
};
export type LookupResponse = {
  items: LookupItem[];
  pagination: {
    [key: string]: any;
  };
};
export type ErrorItem = {
  /** Machine-readable error code (snake_case). */
  code: string;
  /** Human-readable error description. */
  message: string;
  /** Field name, present only for validation errors. */
  field?: string;
};
export type ErrorResponse = {
  errors: ErrorItem[];
};
export type CustomerClassList = {
  id: number;
  name: string;
  description: string;
  location_count: number;
};
export type PaginationInfo = {
  count: number;
  number: number;
  pages: number;
};
export type CustomerClassesListResponse = {
  items: CustomerClassList[];
  pagination: PaginationInfo;
};
export type CustomerClassDetail = {
  name: string;
  description?: string;
  location_ids?: number[];
};
export type CustomerClassDetailRead = {
  id: number;
  name: string;
  description?: string;
  location_ids?: number[];
};
export type CustomerClassResponse = {
  customer_class: CustomerClassDetail;
};
export type CustomerClassResponseRead = {
  customer_class: CustomerClassDetailRead;
};
export type CustomerClassCreateRequest = {
  name: string;
  description?: string;
  location_ids?: number[];
};
export type CustomerClassRequestRequest = {
  customer_class: CustomerClassCreateRequest;
};
export type SuccessResponse = {
  success: boolean;
};
export type LocationBillingStatusUpdateResult = {
  success: boolean;
  /** Billing status after the update. */
  billing_status: string;
  /** ID of the updated location. */
  location_id: number;
};
export type BillingStatusEnum = 'paid' | 'in_process' | 'past_due';
export type LocationBillingStatusUpdateRequest = {
  /** Billing status to apply to the location.
    
    * `paid` - Paid
    * `in_process` - In Process
    * `past_due` - Past Due */
  billing_status: BillingStatusEnum;
};
export type LocationPaymentTermsUpdateResult = {
  success: boolean;
  /** ID of the updated location. */
  location_id: number;
  /** Effective payment terms after the update, or null if cleared. */
  payment_terms: string | null;
};
export type PaymentTermsEnum =
  | 'net_0'
  | 'net_3'
  | 'net_7'
  | 'net_10'
  | 'net_14'
  | 'net_15'
  | 'net_30'
  | 'net_45'
  | 'net_60'
  | 'net_90'
  | 'net_120'
  | 'net_180';
export type LocationPaymentTermsUpdateRequest = {
  /** Payment terms value, or null to reset to the vendor/dispensary baseline.
    
    * `None` - ---------
    * `net_0` - Net 0
    * `net_3` - Net 3
    * `net_7` - Net 7
    * `net_10` - Net 10
    * `net_14` - Net 14
    * `net_15` - Net 15
    * `net_30` - Net 30
    * `net_45` - Net 45
    * `net_60` - Net 60
    * `net_90` - Net 90
    * `net_120` - Net 120
    * `net_180` - Net 180 */
  payment_terms: PaymentTermsEnum | null;
};
export type LocationBillingStatusBulkUpdateResult = {
  success: boolean;
  /** Billing status after the update. */
  billing_status: string;
  /** Number of VDL rows updated. */
  updated_count: number;
  /** Validated and sorted IDs of locations that were updated. */
  location_ids: number[];
};
export type LocationBillingStatusBulkUpdateRequest = {
  /** Billing status to apply to the location.
    
    * `paid` - Paid
    * `in_process` - In Process
    * `past_due` - Past Due */
  billing_status: BillingStatusEnum;
  /** IDs of locations to update. Must be accessible by the authenticated vendor. */
  location_ids: number[];
};
export type LocationPaymentTermsBulkUpdateResult = {
  success: boolean;
  /** Number of VDL rows updated. */
  updated_count: number;
  /** Validated and sorted IDs of locations that were updated. */
  location_ids: number[];
  /** Payment terms applied to all locations, or null if cleared. */
  payment_terms: string | null;
};
export type LocationPaymentTermsBulkUpdateRequest = {
  /** Payment terms value, or null to reset to the vendor/dispensary baseline.
    
    * `None` - ---------
    * `net_0` - Net 0
    * `net_3` - Net 3
    * `net_7` - Net 7
    * `net_10` - Net 10
    * `net_14` - Net 14
    * `net_15` - Net 15
    * `net_30` - Net 30
    * `net_45` - Net 45
    * `net_60` - Net 60
    * `net_90` - Net 90
    * `net_120` - Net 120
    * `net_180` - Net 180 */
  payment_terms: PaymentTermsEnum | null;
  /** IDs of locations to update. Must be accessible by the authenticated vendor. */
  location_ids: number[];
};
export type CustomerTaxesFee = {
  location_id: number;
  location_name: string;
  dispensary_name: string;
  note: string;
  shipping_fee: string;
  tax_rate: string;
};
export type CustomerTaxesFeesListResponse = {
  items: CustomerTaxesFee[];
  pagination: PaginationInfo;
};
export type CustomerTaxesFeeUpdateRequest = {
  location_id: number;
  shipping_fee: string;
  tax_rate: string;
  note?: string;
};
export type CustomerTaxesFeesBulkUpdateRequestRequest = {
  updates: CustomerTaxesFeeUpdateRequest[];
};
export type ActivityTypeEnum = 'phone_call' | 'email' | 'meeting' | 'other';
export type ActivityStatusEnum = 'new' | 'complete' | 'past_due';
export type Activity = {
  title: string;
  description?: string;
  activity_type?: ActivityTypeEnum;
  activity_status?: ActivityStatusEnum;
  due_at?: string | null;
  contact_id?: number | null;
  contact_type?: string | null;
};
export type ActivityRead = {
  id: number;
  title: string;
  description?: string;
  activity_type?: ActivityTypeEnum;
  activity_status?: ActivityStatusEnum;
  due_at?: string | null;
  user_id: number;
  user_email: string;
  contact_id?: number | null;
  contact_type?: string | null;
  contact_name: string;
  contact_email: string;
  contact_phone: string;
};
export type ActivitiesListResponse = {
  items: Activity[];
  pagination: PaginationInfo;
};
export type ActivitiesListResponseRead = {
  items: ActivityRead[];
  pagination: PaginationInfo;
};
export type ActivityResponse = {
  activity: Activity;
};
export type ActivityResponseRead = {
  activity: ActivityRead;
};
export type ActivityRequest = {
  title: string;
  description?: string;
  activity_type?: ActivityTypeEnum;
  activity_status?: ActivityStatusEnum;
  due_at?: string | null;
  contact_id?: number | null;
  contact_type?: string | null;
};
export type ActivityRequestRequest = {
  activity: ActivityRequest;
};
export type ActivityExportRequest = {
  activity_ids?: number[];
};
export type DispensaryContact = {
  id: number;
};
export type DispensaryContactRead = {
  id: number;
  contact_type: string;
  first_name: string;
  last_name: string;
  email: string;
  phone: string;
  role: string;
};
export type ContactsListResponse = {
  contacts: DispensaryContact[];
};
export type ContactsListResponseRead = {
  contacts: DispensaryContactRead[];
};
export type SalesRep = {
  id: number;
  name: string;
};
export type CustomerSummary = {
  customer_id: string;
  customer_name: string;
  number_of_locations: number;
  total_dollars_ordered: string;
  number_of_orders: number;
  average_total_per_order: string;
  basis_date: string;
  billing_status: string | null;
  engagement_status: string;
  last_order_date: string | null;
  default_sales_rep: SalesRep[];
  default_payment_terms: string | null;
};
export type CustomerSummaryPaginatedResponse = {
  /** Total number of items matching the query. */
  count: number;
  /** URL for the next page, or null if this is the last page. */
  next: string | null;
  /** URL for the previous page, or null if this is the first page. */
  previous: string | null;
  results: CustomerSummary[];
};
export type ContactMutationResponse = {
  success: boolean;
  contact?: DispensaryContact;
};
export type ContactMutationResponseRead = {
  success: boolean;
  contact?: DispensaryContactRead;
};
export type ContactRequestRequest = {
  first_name?: string;
  last_name?: string;
  email: string;
  phone?: string;
  role?: string;
};
export type Address = {
  street_address_1: string | null;
  street_address_2: string | null;
  city: string | null;
  country_area: string | null;
  postal_code: string | null;
  phone: string | null;
};
export type CustomerInfo = {
  id: number;
  name: string;
  website: string | null;
  email: string | null;
  corporate_address: Address | null;
  has_bank_account: boolean;
  has_orders: boolean;
};
export type VendorDispensaryInfo = {
  id: number;
  basis_date: string;
  payment_terms: string | null;
  billing_status: string;
  leafpay_status: string;
  sales_rep_ids: number[];
};
export type OptionItem = {
  value: string;
  label: string;
};
export type Options = {
  sales_reps: OptionItem[];
  basis_date: OptionItem[];
  payment_terms: OptionItem[];
  billing_status: OptionItem[];
  leafpay_status: OptionItem[];
};
export type Permissions = {
  can_edit: boolean;
  contacts_visible: boolean;
  has_sage: boolean;
  leafpay_status_disabled: boolean;
};
export type CustomerDetailsResponseEnvelope = {
  customer: CustomerInfo;
  vendor_dispensary: VendorDispensaryInfo;
  options: Options;
  permissions: Permissions;
};
export type CustomerDetailsUpdateResponse = {
  success: boolean;
};
export type BasisDateEnum = 'on_approval' | 'upon_delivery';
export type LeafpayStatusEnum = 'vendor_default' | 'on' | 'off';
export type PatchedCustomerSettingsRequest = {
  basis_date?: BasisDateEnum;
  payment_terms?: PaymentTermsEnum | null;
  billing_status?: BillingStatusEnum;
  leafpay_status?: LeafpayStatusEnum;
  sales_rep_ids?: number[];
};
export type CustomerLocationDetail = {
  id: number;
  name: string;
  license_number: string;
  address: Address | null;
  email: string;
  hours_of_operation: string;
  delivery_instructions: string | null;
  sage_customer_id: string | null;
  sales_rep_ids: number[];
  payment_terms: string | null;
  billing_status: string;
};
export type CustomerDetailsLocationsResponse = {
  count: number;
  next: number | null;
  previous: number | null;
  results: CustomerLocationDetail[];
};
export type PatchedLocationSalesRepsRequest = {
  sales_rep_ids?: number[];
};
export type CustomerNote = {
  note: string;
};
export type CustomerNoteRead = {
  id: number;
  note: string;
  created_by: string;
  created_at: string;
};
export type NotesListResponse = {
  notes: CustomerNote[];
};
export type NotesListResponseRead = {
  notes: CustomerNoteRead[];
};
export type NoteMutationResponse = {
  success: boolean;
  note?: CustomerNote;
};
export type NoteMutationResponseRead = {
  success: boolean;
  note?: CustomerNoteRead;
};
export type NoteRequestRequest = {
  note: string;
};
export type CustomerBulkUpdateResult = {
  success: boolean;
  updated_count: number;
  customer_ids: number[];
  /** Sales reps added. Present only when sales_rep_ids was in the request. */
  added_count?: number;
  /** Sales reps removed. Present only when sales_rep_ids was in the request. */
  removed_count?: number;
};
export type CustomerBulkUpdateRequest = {
  customer_ids: number[];
  payment_terms?: PaymentTermsEnum | null;
  billing_status?: BillingStatusEnum;
  basis_date?: BasisDateEnum;
  leafpay_status?: LeafpayStatusEnum;
  sales_rep_ids?: number[] | null;
};
export type ChoiceItem = {
  value: string | null;
  label: string;
};
export type BulkUpdateChoicesResponse = {
  payment_terms: ChoiceItem[];
  billing_status: ChoiceItem[];
  basis_date: ChoiceItem[];
  leafpay_status: ChoiceItem[];
};
export type ImportProduct = {
  defaultCaseSize?: number | null;
  defaultVariantPrice?: string | null;
  importStrainId?: number | null;
  name?: string;
  productId?: number;
  remappedProductId?: number | null;
  selectedForImport?: boolean;
  strainId?: number | null;
};
export type FinalizationEntity = {
  name: string;
};
export type FinalizationEntityRead = {
  id: number;
  name: string;
};
export type FinalizationStrain = {
  id: number;
  name: string;
  phenotype: string;
};
export type ImportProductRead = {
  importValidations?: {
    [key: string]: any;
  };
  categories: FinalizationEntityRead[];
  defaultCaseSize?: number | null;
  defaultVariantPrice?: string | null;
  id: number;
  importStrain?: FinalizationStrain;
  importStrainId?: number | null;
  name?: string;
  product: FinalizationEntityRead;
  productId?: number;
  remappedProduct?: FinalizationEntityRead;
  remappedProductId?: number | null;
  selectedForImport?: boolean;
  strain: FinalizationStrain;
  strainId?: number | null;
};
export type ImportProductListResponse = {
  count: number;
  number: number;
  pages: number;
  importProducts?: ImportProduct[];
};
export type ImportProductListResponseRead = {
  count: number;
  number: number;
  pages: number;
  importProducts?: ImportProductRead[];
};
export type ImportProductPartialUpdateResponse = {
  importProduct?: ImportProduct;
};
export type ImportProductPartialUpdateResponseRead = {
  importProduct?: ImportProductRead;
};
export type ImportProductRequest = {
  defaultCaseSize?: number | null;
  defaultVariantPrice?: string | null;
  importStrainId?: number | null;
  name?: string;
  productId?: number;
  remappedProductId?: number | null;
  selectedForImport?: boolean;
  strainId?: number | null;
};
export type ImportProductRequestWrite = {
  categoryIds?: number[];
  defaultCaseSize?: number | null;
  defaultVariantPrice?: string | null;
  importStrainId?: number | null;
  name?: string;
  productId?: number;
  remappedProductId?: number | null;
  selectedForImport?: boolean;
  strainId?: number | null;
};
export type PatchedImportProductPartialUpdateRequest = {
  importProduct?: ImportProductRequest;
};
export type PatchedImportProductPartialUpdateRequestWrite = {
  importProduct?: ImportProductRequestWrite;
};
export type ImportProductDeselectAllResponse = {
  updated: number;
};
export type ImportProductSelectAllResponse = {
  updated: number;
};
export type ImportProductValidateResponse = {
  valid: boolean;
};
export type ImportStrain = {
  name?: string;
  phenotype?: string | null;
  selectedForImport?: boolean;
  strainId?: number | null;
};
export type ImportStrainRead = {
  importValidations?: {
    [key: string]: any;
  };
  id: number;
  name?: string;
  phenotype?: string | null;
  selectedForImport?: boolean;
  strain: FinalizationStrain;
  strainId?: number | null;
};
export type ImportStrainListResponse = {
  count: number;
  number: number;
  pages: number;
  importStrains?: ImportStrain[];
};
export type ImportStrainListResponseRead = {
  count: number;
  number: number;
  pages: number;
  importStrains?: ImportStrainRead[];
};
export type ImportStrainPartialUpdateResponse = {
  importStrain?: ImportStrain;
};
export type ImportStrainPartialUpdateResponseRead = {
  importStrain?: ImportStrainRead;
};
export type ImportStrainRequest = {
  name?: string;
  phenotype?: string | null;
  selectedForImport?: boolean;
  strainId?: number | null;
};
export type PatchedImportStrainPartialUpdateRequest = {
  importStrain?: ImportStrainRequest;
};
export type ImportStrainDeselectAllResponse = {
  updated: number;
};
export type ImportStrainSelectAllResponse = {
  updated: number;
};
export type ImportStrainValidateResponse = {
  valid: boolean;
};
export type ImportVariant = {
  batchNumber?: string;
  cannabinoidUnit?: string;
  caseSize?: number;
  fulfillmentLocation?: string | null;
  importProductId?: number | null;
  name?: string;
  price?: string | null;
  productId?: number | null;
  pullNumber?: string;
  quantity?: number;
  selectedForImport?: boolean;
  size?: string;
  sizeUnit?: string;
  totalWeight?: string;
  variantId?: number;
};
export type ImportVariantRead = {
  importValidations?: {
    [key: string]: any;
  };
  batchNumber?: string;
  cannabinoidUnit?: string;
  caseSize?: number;
  fulfillmentLocation?: string | null;
  id: number;
  importProduct?: FinalizationEntityRead;
  importProductId?: number | null;
  name?: string;
  price?: string | null;
  product: FinalizationEntityRead;
  productId?: number | null;
  pullNumber?: string;
  quantity?: number;
  selectedForImport?: boolean;
  size?: string;
  sizeUnit?: string;
  totalWeight?: string;
  variant: FinalizationEntityRead;
  variantId?: number;
};
export type ImportVariantListResponse = {
  count: number;
  number: number;
  pages: number;
  importVariants?: ImportVariant[];
};
export type ImportVariantListResponseRead = {
  count: number;
  number: number;
  pages: number;
  importVariants?: ImportVariantRead[];
};
export type ImportVariantPartialUpdateResponse = {
  importVariant?: ImportVariant;
};
export type ImportVariantPartialUpdateResponseRead = {
  importVariant?: ImportVariantRead;
};
export type ImportVariantRequest = {
  batchNumber?: string;
  cannabinoidUnit?: string;
  caseSize?: number;
  fulfillmentLocation?: string | null;
  importProductId?: number | null;
  name?: string;
  price?: string | null;
  productId?: number | null;
  pullNumber?: string;
  quantity?: number;
  selectedForImport?: boolean;
  size?: string;
  sizeUnit?: string;
  totalWeight?: string;
  variantId?: number;
};
export type PatchedImportVariantPartialUpdateRequest = {
  importVariant?: ImportVariantRequest;
};
export type ImportVariantDeselectAllResponse = {
  updated: number;
};
export type ImportVariantSelectAllResponse = {
  updated: number;
};
export type ImportVariantValidateResponse = {
  valid: boolean;
};
export type CustomerLocation = {
  location_id: string;
  location_name: string;
  customer_id: string;
  customer_name: string;
  license_number: string;
  total_dollars_ordered: string;
  number_of_orders: number;
  average_total_per_order: string;
  customer_classes: string[];
  sales_rep: string | null;
  sales_reps: string[];
  sales_rep_ids: number[];
  payment_terms: string | null;
  billing_status: string;
  location_status: string;
  engagement_status: string;
};
export type CustomerLocationPaginatedResponse = {
  /** Total number of items matching the query. */
  count: number;
  /** URL for the next page, or null if this is the last page. */
  next: string | null;
  /** URL for the previous page, or null if this is the first page. */
  previous: string | null;
  results: CustomerLocation[];
};
export type LocationBulkUpdateResult = {
  success: boolean;
  updated_count: number;
  location_ids: number[];
  added_count: number;
  removed_count: number;
};
export type LocationBulkUpdateRequest = {
  location_ids: number[];
  sales_rep_ids: number[] | null;
};
export type LocationCustomerClassesBulkUpdateResult = {
  /** Location IDs for the bulk update. Request values must be accessible by the authenticated vendor. */
  location_ids: number[];
  /** Customer class IDs for the override. Empty list clears vendor customer classes from the locations. */
  customer_class_ids: number[];
  success: boolean;
  /** Number of locations updated. */
  updated_count: number;
  /** Number of customer class location links created. */
  added_count: number;
  /** Number of existing vendor customer class links removed. */
  removed_count: number;
};
export type LocationCustomerClassesBulkUpdateRequest = {
  /** Location IDs for the bulk update. Request values must be accessible by the authenticated vendor. */
  location_ids: number[];
  /** Customer class IDs for the override. Empty list clears vendor customer classes from the locations. */
  customer_class_ids: number[];
};
export type StatusEnum = 'active' | 'inactive';
export type SalesChannel = {
  name: string;
  status?: StatusEnum;
};
export type SalesChannelRead = {
  id: number;
  name: string;
  status?: StatusEnum;
  has_allocated_inventory: boolean;
  allocated_quantity: string;
};
export type SalesChannelsListResponse = {
  items: SalesChannel[];
  pagination: PaginationInfo;
};
export type SalesChannelsListResponseRead = {
  items: SalesChannelRead[];
  pagination: PaginationInfo;
};
export type SalesChannelResponse = {
  sales_channel: SalesChannel;
};
export type SalesChannelResponseRead = {
  sales_channel: SalesChannelRead;
};
export type SalesChannelRequest = {
  name: string;
  status?: StatusEnum;
};
export type SalesChannelRequestRequest = {
  sales_channel: SalesChannelRequest;
};
export type VendorUser = {
  id: number;
};
export type VendorUserRead = {
  id: number;
  name: string;
  email: string;
};
export type VendorUsersListResponse = {
  items: VendorUser[];
};
export type VendorUsersListResponseRead = {
  items: VendorUserRead[];
};
export const {
  useVendorCustomerClassSearchListQuery,
  useVendorCustomerClassesListQuery,
  useVendorCustomerClassesCreateMutation,
  useVendorCustomerClassesRetrieveQuery,
  useVendorCustomerClassesUpdateMutation,
  useVendorCustomerClassesDestroyMutation,
  useVendorCustomerLocationsBillingStatusUpdateMutation,
  useVendorCustomerLocationsPaymentTermsUpdateMutation,
  useVendorCustomerLocationsBillingStatusBulkUpdateCreateMutation,
  useVendorCustomerLocationsPaymentTermsBulkUpdateCreateMutation,
  useVendorCustomerTaxesFeesListQuery,
  useVendorCustomerTaxesFeesBulkUpdateCreateMutation,
  useVendorCustomerActivitiesListQuery,
  useVendorCustomerActivitiesCreateMutation,
  useVendorCustomerActivitiesRetrieveQuery,
  useVendorCustomerActivitiesUpdateMutation,
  useVendorCustomerActivitiesDestroyMutation,
  useVendorCustomerActivitiesExportCreateMutation,
  useVendorCustomerContactsListQuery,
  useVendorCustomersListQuery,
  useVendorCustomersContactsListQuery,
  useVendorCustomersContactsCreateMutation,
  useVendorCustomersContactsUpdateMutation,
  useVendorCustomersContactsDestroyMutation,
  useVendorCustomersDetailsRetrieveQuery,
  useVendorCustomersDetailsPartialUpdateMutation,
  useVendorCustomersLocationsRetrieveQuery,
  useVendorCustomersLocationsSalesRepsPartialUpdateMutation,
  useVendorCustomersNotesListQuery,
  useVendorCustomersNotesCreateMutation,
  useVendorCustomersNotesUpdateMutation,
  useVendorCustomersNotesDestroyMutation,
  useVendorCustomersBulkUpdateCreateMutation,
  useVendorCustomersBulkUpdateChoicesRetrieveQuery,
  useVendorImportBatchesImportProductsListQuery,
  useVendorImportBatchesImportProductsPartialUpdateMutation,
  useVendorImportBatchesImportProductsDeselectAllCreateMutation,
  useVendorImportBatchesImportProductsSelectAllCreateMutation,
  useVendorImportBatchesImportProductsValidateRetrieveQuery,
  useVendorImportBatchesImportStrainsListQuery,
  useVendorImportBatchesImportStrainsPartialUpdateMutation,
  useVendorImportBatchesImportStrainsDeselectAllCreateMutation,
  useVendorImportBatchesImportStrainsSelectAllCreateMutation,
  useVendorImportBatchesImportStrainsValidateRetrieveQuery,
  useVendorImportBatchesImportVariantsListQuery,
  useVendorImportBatchesImportVariantsPartialUpdateMutation,
  useVendorImportBatchesImportVariantsDeselectAllCreateMutation,
  useVendorImportBatchesImportVariantsSelectAllCreateMutation,
  useVendorImportBatchesImportVariantsValidateRetrieveQuery,
  useVendorImportBatchesProcessCreateMutation,
  useVendorLocationsListQuery,
  useVendorLocationsBulkUpdateCreateMutation,
  useVendorLocationsCustomerClassesBulkUpdateCreateMutation,
  useVendorSalesChannelsListQuery,
  useVendorSalesChannelsCreateMutation,
  useVendorSalesChannelsRetrieveQuery,
  useVendorSalesChannelsUpdateMutation,
  useVendorSalesRepSearchListQuery,
  useVendorVendorUsersListQuery,
} = injectedRtkApi;
